import React from 'react';
import map from 'lodash/map';
import cn from 'classnames';

import ContentPreviewItem from './ContentPreviewItem';
import ContentPreviewLink from './ContentPreviewLink';

function ContentPreview({ editPlaylistId, visible, contents }) {
  return (
    <div
      className={cn('content-preview', {
        'content-preview--active': visible,
      })}
    >
      <ContentPreviewLink id={editPlaylistId} />
      {map(contents, (content, index) => (
        <ContentPreviewItem
          {...content}
          id={`preview-item-${content.id}-${index}`}
        />
      ))}
    </div>
  );
}

export default ContentPreview;
